import { OutletId } from '@/shared/models/Outlet';

export interface WorkshopTeamId { __workshopTeamId: number}

export default class WorkshopTeam {
  id!: WorkshopTeamId;
  outletId!: OutletId;
  description!: string;
}